module.exports = __webpack_public_path__ + "img/bg-flowers.c59ab3ce.png";